import { mobiClient } from '@/services/axiosConfig'
import { HitoneAddPlaylistContentReq, HitoneAddPlaylistContentRes, HitoneCategoriesRes, HitoneContentRes, HitoneCreatePlaylistReq, HitoneCreatePlaylistRes, HitoneDeletePlaylistContentReq, HitoneDeletePlaylistContentRes, HitoneDownloadReq, HitoneDownloadRes, HitoneGiftReq, HitoneGiftRes, HitonePlaylistContentsRes, HitonePlaylistScheduleReq, HitonePlaylistScheduleRes, HitonePlaylistsRes, HitoneSearchReq, HitoneSongsReq, HitoneSongsRes, HitoneStatusRes, HitoneUpdatePlaylistReq, HitoneUpdatePlaylistRes } from './types'

export const getNewSongs = async (req: HitoneSongsReq): Promise<HitoneSongsRes | undefined> => {
  try {
    const res = await mobiClient.get('/hitone/new-songs', { params: req })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getTopSongs = async (req: HitoneSongsReq): Promise<HitoneSongsRes | undefined> => {
  try {
    const res = await mobiClient.get('/hitone/top-songs', { params: req })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getCategories = async (): Promise<HitoneCategoriesRes | undefined> => {
  try {
    const res = await mobiClient.get('/hitone/categories')
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getStatus = async (isdn: string): Promise<HitoneStatusRes | undefined> => {
  try {
    const res = await mobiClient.get('/hitone/status', {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const search = async (req: HitoneSearchReq): Promise<HitoneSongsRes | undefined> => {
  try {
    const res = await mobiClient.post('/hitone/search', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getPlaylists = async (isdn: string, page?: number, pageSize?: number): Promise<HitonePlaylistsRes | undefined> => {
  try {
    const params: Record<string, number> = {}
    if (page !== undefined) params.page = page
    if (pageSize !== undefined) params.pageSize = pageSize
    const res = await mobiClient.get('/hitone/playlists', {
      params,
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const createPlaylist = async (req: HitoneCreatePlaylistReq, isdn: string): Promise<HitoneCreatePlaylistRes | undefined> => {
  try {
    const res = await mobiClient.post('/hitone/playlists', req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const deletePlaylist = async (playlistId: number, isdn: string): Promise<{ success: boolean, message?: string } | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/delete`, {}, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const updatePlaylist = async (playlistId: number, req: HitoneUpdatePlaylistReq, isdn: string): Promise<HitoneUpdatePlaylistRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/update`, req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getPlaylistContents = async (playlistId: number, isdn: string, page?: number, pageSize?: number): Promise<HitonePlaylistContentsRes | undefined> => {
  try {
    const params: Record<string, number> = {}
    if (page !== undefined) params.page = page
    if (pageSize !== undefined) params.pageSize = pageSize
    const res = await mobiClient.get(`/hitone/playlists/${playlistId}/contents`, {
      params,
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const deletePlaylistContent = async (playlistId: number, req: HitoneDeletePlaylistContentReq, isdn: string): Promise<HitoneDeletePlaylistContentRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/contents/delete`, req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const addPlaylistContent = async (playlistId: number, req: HitoneAddPlaylistContentReq, isdn: string): Promise<HitoneAddPlaylistContentRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/contents`, req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const updatePlaylistSchedule = async (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string): Promise<HitonePlaylistScheduleRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/schedule`, req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const updateFavoriteSchedule = async (playlistId: number, req: HitonePlaylistScheduleReq, isdn: string): Promise<HitonePlaylistScheduleRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/playlists/${playlistId}/box-schedule`, req, {
      headers: { isdn }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getContentById = async (contentId: string, isdn?: string): Promise<HitoneContentRes | undefined> => {
  try {
    const headers = isdn != null && isdn.trim() !== '' ? { isdn } : undefined
    const res = await mobiClient.get(`/hitone/contents/${contentId}`, { headers })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const downloadContent = async (req: HitoneDownloadReq, isdn: string): Promise<HitoneDownloadRes | undefined> => {
  try {
    const res = await mobiClient.post('/hitone/contents/download', req, {
      headers: {
        'Content-Type': 'application/json',
        isdn
      }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const giftContent = async (contentCode: string, req: HitoneGiftReq, isdn: string): Promise<HitoneGiftRes | undefined> => {
  try {
    const res = await mobiClient.post(`/hitone/contents/${contentCode}/gift`, req, {
      headers: {
        'Content-Type': 'application/json',
        isdn
      }
    })
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
